<template>
  <el-dialog
    class="homepage-settings-dialog"
    :title="'Настройки'"
    append-to-body
    :close-on-click-modal="false"
    :visible.sync="show"
    :width="'50%'"
  >
    <div v-if="show">

      <el-form
        label-position="left"
        label-width="180px"
        style="width: 100%"
        size="mini"
      >
        <el-form-item label="Показывать дашборды">
          <el-switch v-model="settings.tabsVisible"></el-switch>
        </el-form-item>
        <el-form-item label="Расположение страниц">
          <el-select v-model="settings.tabsPosition">
            <el-option label="Сверху" value="top"></el-option>
            <el-option label="Справа" value="right"></el-option>
            <el-option label="Снизу" value="bottom"></el-option>
            <el-option label="Слева" value="left"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Рамка дашборда">
          <el-select v-model="settings.tabsType" default-first-option>
            <el-option label="Без рамки" value=""></el-option>
            <el-option label="Только сверху" value="card"></el-option>
            <el-option label="Полное" value="border-card"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Главный дашборд">
          <el-select v-model="homepage.default_dashboard_id">
            <el-option
              v-for="(dashboard, dIndex) in [...dashboards, ...standardDashboards]"
              :key="dIndex"
              :label="dashboard.settings.name"
              :value="dashboard.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="$canAndRulesPass(user, $permissions.HOME_DASHBOARD.DASHBOARD_MANAGE)"
          label="Мои дашборды"
        >
          <Container
            @drop="onDrop"
            drag-handle-selector=".column-drag-handle"
          >
            <Draggable
              v-for="(dashboard, dIndex) in dashboards"
              :key="dIndex"
            >
              <div style="display: flex; margin-bottom: 5px">
                <div class="column-drag-handle" style="margin-right: 10px; cursor: move">
                  <i class="fas fa-bars"></i>
                </div>
                <el-input size="mini" v-model="dashboard.settings.name"></el-input>
                <el-popconfirm
                  confirm-button-text='Да'
                  cancel-button-text='нет'
                  icon="el-icon-question"
                  title="Вы уверены, что хотите удалить дашборд?"
                  @confirm="deleteDashboard(dIndex)"
                >
                  <el-button
                    slot="reference"
                    style="margin-left: 10px"
                    class="table-action-button"
                    type="default"
                    round
                    size="mini"
                    icon="far fa-trash-alt"
                  >
                  </el-button>
                </el-popconfirm>
              </div>

            </Draggable>
          </Container>

          <el-button
            size="mini"
            type="text"
            icon="fas fa-plus"
            @click="addDashboard"
          >Добавить дашборд</el-button>
        </el-form-item>
      </el-form>
    </div>


    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="show = false;">Закрыть</el-button>
      <el-button type="primary" size="small" @click="saveSettings">Сохранить</el-button>
    </span>
  </el-dialog>
</template>

<script>

import {Container, Draggable} from "vue-dndrop";
import {applyDragForDndrop} from "@/utils/helpers";
import {mapGetters} from "vuex";

export default {
  name: 'HomepageSettingsDialog',
  components: {Container, Draggable},
  props: {},
  computed: {
    ...mapGetters(['user']),
  },
  data() {
    return {
      loading: false,
      show: false,

      homepage: null,
      settings: {
        tabsVisible: false,
        tabsType: null,
        tabsPosition: 'top',
        defaultDashboard: null,
      },
      dashboards: [],
      standardDashboards: [],

    }
  },

  methods: {
    async open(homepage, dashboards, standardDashboards){
      this.homepage = homepage;
      this.settings = {...homepage.settings};
      this.dashboards = [...dashboards];
      this.standardDashboards = [...standardDashboards];

      this.show = true;
    },

    addDashboard(){
      this.dashboards.push({
        settings:{
          name: 'Новый дашборд',
        }
      })
    },

    deleteDashboard(dIndex){
      this.dashboards.splice(dIndex, 1);
    },


    onDrop(dropResult) {
      this.dashboards = applyDragForDndrop(this.dashboards, dropResult);
    },

    saveSettings() {
      this.loading = true;
      this.$api.homeDashboard.saveHomepageSettings({
        default_dashboard_id: this.homepage.default_dashboard_id,
        settings: this.settings,
        dashboards: this.dashboards,
      })
        .then((data) => {
          this.$emit('saved');
          this.show = false;
        })
        .finally(()=>{
          this.loading = false;
        })


    },


  }
}
</script>

<style lang="scss">
.widget-settings-dialog .el-tabs__content{
  overflow: unset;
}

.el-tabs__new-tab{
  width: 100px;

  &:after{
    content: 'Добавить';
  }
}

</style>